import { activitiesGetActivity, activitiesSignupActivity, type ViduV1Work } from '@/app/services/vidu';

export { activitiesListWorks } from '@/app/services/vidu/sdk.gen';

/**
 * 获取活动详情
 */
export const getActivity = (id: ViduV1Work['activity_id']) => {
  return activitiesGetActivity({
    path: { id },
  });
};

export const signUpRewardActivity = (activityId: string) =>
  activitiesSignupActivity({
    path: { activity_id: activityId },
    body: {
      activity_id: activityId,
    },
  });
